var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"checkbox",class:_vm.getClass,on:{"click":_vm.updateInput}})])
}
var staticRenderFns = []

export { render, staticRenderFns }